<template>
  <div>
    <UserProfileHeader>
      <div class="tab-buttons">
        <OutlineButton
          :active="this.tab == 'plano'"
          @click="redirectTab('plano')"
        >Plano</OutlineButton>

        <OutlineButton
          :active="this.tab == 'dados'"
          @click="redirectTab('dados')"
        >Dados</OutlineButton>

        <OutlineButton
          :active="this.tab == 'certificados'"
          @click="redirectTab('certificados')"
        >Certificados</OutlineButton>
      </div>
    </UserProfileHeader>

    <div class="tab-content">
      <div class="content">
        <UserProfileSubscriptionTab
          v-if="tab == 'plano'"
        />

        <UserProfileAccountFormTab
          v-if="tab == 'dados'"
        />

        <UserProfileCertificatesTab
          v-if="tab == 'certificados'"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import UserProfileHeader from '@/components/user/profile/UserProfileHeader'
  import OutlineButton from '@/components/buttons/OutlineButton'
  import UserProfileSubscriptionTab from '@/components/user/profile/tabs/UserProfileSubscriptionTab'
  import UserProfileCertificatesTab from '@/components/user/profile/tabs/UserProfileCertificatesTab'
  import UserProfileAccountFormTab from '@/components/user/profile/tabs/UserProfileAccountFormTab'

  const TABS = ['plano', 'dados', 'certificados'];

  export default {
    components: {
      UserProfileHeader,
      OutlineButton,
      UserProfileSubscriptionTab,
      UserProfileCertificatesTab,
      UserProfileAccountFormTab
    },
    metaInfo () {
      return {
        title: this.pageTitle,
      }
    },
    mounted () {
      if (!this.tab || !TABS.includes(this.tab)) {
        this.redirectDefaultTab()
      }
    },
    computed: {
      tab () {
        return this.$route.params.tab
      },
      pageTitle () {
        const tab = this.tab.charAt(0).toUpperCase() + this.tab.slice(1)
        return `Meu Perfil - ${tab} | CyberClass`
      }
    },
    methods: {
      redirectTab (tab) {
        if (tab != this.tab) {
          this.$router.push({ name: 'user.account', params: {tab} })
        }
      },
      redirectDefaultTab () {
        this.$router.replace({
          name: 'user.account',
          params: { 'tab': TABS[0] }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .tab-buttons {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin: 20px 0;

    @media (max-width: $mobileBreakpoint) {
      flex-direction: column;
      width: 190px;
    }
  }

  .tab-content {
    padding: 20px 0;

    .content {
      padding: 0 15px;
      max-width: 750px;
      margin: 0 auto;
    }
  }
</style>